import { Component, OnInit, Input, Output, EventEmitter, Injector, ViewEncapsulation } from '@angular/core';
import { NameValueOfString, RegionType } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';

@Component({
    selector: 'regionTypesMultiselect',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './regionTypes-multiselect.component.html'
})

export class RegionTypesMultiSelectComponent extends AppComponentBase implements OnInit {

    @Input()
    set selectedItems(items: NameValueOfString[]) {
        this._selectedItems = items || [];
        this.selectedItemsChange.emit(this._selectedItems);
    };
    get selectedItems(): NameValueOfString[] {
        return this._selectedItems;
    }
    private _exclude: string[] = [];
    @Input()
    set exclude(exclude: string[]) {
        this._exclude = exclude;
        this.setRegionTypes();
    }
    @Input() name = 'RegionTypeFilter';
    @Output() selectedItemsChange: EventEmitter<NameValueOfString[]> = new EventEmitter<NameValueOfString[]>();

    regionTypeValues = RegionType;

    options: NameValueOfString[] = new Array<NameValueOfString>();

    private _selectedItems: NameValueOfString[] = [];
    @Input() placeholder = this.l('Region');

    constructor(injector: Injector) {
       super(injector)
    }

    ngOnInit() {
        this.setRegionTypes();
    }

    regionTypeKeys(): Array<string> {
        const keys = Object.keys(this.regionTypeValues);
        return keys.slice(keys.length / 2);
    }

    setRegionTypes(): void {
        this.options = [];

        this.regionTypeKeys().forEach(e => {
            if (!this._exclude.includes(e)) {
                this.options.push(
                    new NameValueOfString({ name: this.l(e), value: this.regionTypeValues[e] })
                );
            }
        });
    }

    onPanelHide() {
        document.getElementById(this.name).focus();
    }
}